<template>
  <div class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
    <div class="text-[#414141] font-sans">
      <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">{{ program?.program_name || 'Program Evaluation' }}</h3>
      <div v-if="!program" class="text-center py-8 text-gray-500">
        Program not found. Please check the program ID.
      </div>
      <div v-else>
        <!-- Tabs -->
        <div class="mb-6">
          <div class="flex space-x-4 border-b border-gray-200">
            <button
              v-for="(tab, index) in tabs"
              :key="index"
              @click="activeTab = index"
              :class="[
                'px-4 py-2 text-sm font-medium border-b-2 -mb-px flex items-center gap-1.5',
                activeTab === index
                  ? 'border-[#00423D] text-[#00423D]'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              ]"
            >
              {{ tab.name }}
            </button>
          </div>
        </div>
        <div v-if="activeTab === 0">
          <CoreProgramOutcomesQuestion :program-id="program.id" ref="outcomesRef" />
        </div>
        <div v-else-if="activeTab === 1">
          <CoreProgramOutputsQuestion :program-id="program.id" ref="outputsRef" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import CoreProgramOutcomesQuestion from '@/components/CoreProgramOutcomesQuestion.vue';
import CoreProgramOutputsQuestion from '@/components/CoreProgramOutputsQuestion.vue';

const tabs = [
  { name: 'Outcomes' },
  { name: 'Outputs' }
];
const activeTab = ref(0);
const outcomesRef = ref(null);
const outputsRef = ref(null);
const route = useRoute();
const programSlug = computed(() => route.params.slug);
const corePrograms = JSON.parse(localStorage.getItem('corePrograms') || '[]');
const program = computed(() => corePrograms.find(p => p.program_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') === programSlug.value));

// Validation for parent/step logic
const validateCurrentTab = async () => {
  if (activeTab.value === 0 && outcomesRef.value && outcomesRef.value.validate) {
    return await outcomesRef.value.validate();
  }
  if (activeTab.value === 1 && outputsRef.value && outputsRef.value.validate) {
    return await outputsRef.value.validate();
  }
  return true;
};

defineExpose({ validateCurrentTab, activeTab, tabs });
</script> 